<template>
  <div>
    <transition name="welfareScale" v-on:after-leave="$emit('closed')">
      <div class="pwa-wrap" ref="welScaleWrap" v-if="showPop">
        <div class="install-pwa">
          <div class="close" @click="showPop = !showPop"></div>
          <div class="content">
            <div class="install-title"><AutoFontSize v-if="isShow">{{ $t('title_install_bonus') }}</AutoFontSize></div>
            <div class="txt-1"><AutoFontSize v-if="isShow">{{ $t('subtitle_install_bonus') }}</AutoFontSize></div>
            <div class="txt-2">
              <AutoFontSize v-if="isShow">
                <i18n path="tips_install_bonus" tag="span" class="txt">
                  <span :slot="0" class="colors">{{ $t('title_install_bonus') }}</span>
                </i18n>
              </AutoFontSize>
            </div>
            <div class="award"></div>
            <div v-if="calcShowInstall" class="btn" @click="goInstall">{{ $t('title_install_bonus') }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ameApiDo } from '@/server/api'
import mixins from './mixins'
import { mapState } from 'vuex'
const LOCAL_KEY = '_i_p_a_'
export default {
  name: 'InstallPWA',
  props: ['isShow', 'options'],
  mixins: [mixins],
  data () {
    return {
      showPop: true,
      deferredPrompt: window.__deferredPrompt || undefined,
      flag: window.localStorage.getItem(LOCAL_KEY)
    }
  },
  created () {
    window.addEventListener('beforeinstallprompt', this.showPrompt)
    setTimeout(() => {
      // 时间太早有可能 window.__deferredPrompt 返回 undefined，5s 尝试重新赋值
      if (!this.deferredPrompt) {
        this.deferredPrompt = window.__deferredPrompt || undefined
      }
      this.init()
    }, 5000)
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo'
    }),
    calcShowInstall () {
      const result = window.crtDevice
      const { ua } = result

      const whiteBrowser = ua.includes('Chrome') && this.deferredPrompt
      return !!whiteBrowser
    }
  },
  methods: {
    init () {
      if (!this.calcShowInstall || this.flag >= '1') {
        return this.$emit('delPopup', 'InstallPWA')
      }
      const params = {
        p0: 'web',
        p1: 18,
        p2: 1183,
        p3: 'api',
        fpid: this.userInfo.fpid,
        device_id: this.$utils.getDeviceId(),
        source: 'welfares_center'
      }
      ameApiDo(params).then(res => {
        if (res.is_add_desktop || res.is_recevied) {
          this.$emit('delPopup', 'InstallPWA')
        }
      })
    },
    showPrompt (e) {
      // 防止 Chrome 67 及更早版本自动显示安装提示
      e.preventDefault()
      // 稍后再触发此事件
      this.deferredPrompt = e
    },
    goInstall (type) {
      this.deferredPrompt.prompt()
      // 等待用户反馈
      this.deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            if (this.userInfo.openid) {
              // 从奖励弹窗点击安装
              const params = {
                p0: 'web',
                p1: 18,
                p2: 1107,
                openid: this.userInfo.openid,
                device_id: this.$utils.getDeviceId()
              }
              ameApiDo(params)
                .then(res => {
                  window.localStorage.setItem(LOCAL_KEY, 2)
                  this.$emit('closed', { name: 'ArrivalPanel', options: { type: 'pwa' } })
                  this.$utils.log('save_to_desktop_reward', { save_channel: 'new_user_popup' })
                })
                .catch(err => {
                  console.error(err)
                })
            } else {
              setTimeout(() => {
                window.localStorage.setItem(LOCAL_KEY, 1)
                this.$emit('closed', { name: 'ArrivalPanel', options: { type: 'pwa' } })
              }, 1000)
            }
            this.$utils.log('webgame_shorcut_guide', { type: 'save_shortcut' })
            this.$utils.log('save_to_desktop', { save_channel: 'new_user_popup' })
          }
        })
    },
    startShow () {
      this.$utils.setTransOrigin(document.querySelector('.entrance-wrapper'), this.$refs.welScaleWrap)
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeinstallprompt', this.showPrompt)
  }
}
</script>

<style lang='scss' scoped >
.welfareScale-enter-active, .welfareScale-leave-active {
  transition: all .5s;
}
.welfareScale-enter, .welfareScale-leave-to {
  opacity: 0;
  transform: scale(0);
}
.pwa-wrap {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: 50% 0;
}
.install-pwa {
  width: calc(1305 * var(--unit-px));
  height: calc(673 * var(--unit-px));
  background: url(~@/assets/img/bg_popup_pwa.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
}
.close {
  width: calc(82 * var(--unit-px));
  height: calc(82 * var(--unit-px));
  background: url(~@/assets/img/welfare/icon_close.png) no-repeat center center;
  background-size: 100% 100%;
  position: absolute;
  top: calc(-18 * var(--unit-px));
  right: calc(25 * var(--unit-px));
  cursor: pointer;
}
.content {
  position: absolute;
  top: calc(118 * var(--unit-px));
  right: calc(78 * var(--unit-px));
  width: calc(667 * var(--unit-px));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .install-title {
    width: calc(100% + calc(100 * var(--unit-px)));;
    font-size: calc(54 * var(--unit-px));
    font-weight: 600;
    color: #FFE05B;
    line-height: calc(79 * var(--unit-px));
    letter-spacing: 1px;
    text-shadow: 0px 1px 2px #000000;
  }
  .txt-1 {
    margin-top: calc(11 * var(--unit-px));
    font-size: calc(36 * var(--unit-px));
    line-height: calc(50 * var(--unit-px));
    font-weight: 600;
    color: #FCF163;
    text-shadow: 0px 1px 1px #000000;
    white-space: nowrap;
  }
  .txt-2 {
    width: calc(100% + calc(100 * var(--unit-px)));
    font-size: calc(24 * var(--unit-px));
    margin-top: calc(5 * var(--unit-px));
    height: calc(33 * var(--unit-px));
    line-height: calc(33 * var(--unit-px));
    color: #ffffff;
    .colors {
      color: #DA5308;
    }
  }
  .award {
    width: calc(667 * var(--unit-px));
    height: calc(173 * var(--unit-px));
    background: url(~@/assets/img/welfare/award_install_pwa.png) no-repeat center center;
    background-size: 100% 100%;
    margin-top: calc(45 * var(--unit-px));
  }
  .btn {
    width: calc(540 * var(--unit-px));
    height: calc(90 * var(--unit-px));
    background: url(~@/assets/img/welfare/bg_btn.png) no-repeat center center;
    background-size: 100% 100%;
    margin-top: calc(44 * var(--unit-px));
    cursor: pointer;
    line-height: calc(90 * var(--unit-px));
    text-align: center;
    font-size: calc(31 * var(--unit-px));
    font-weight: 600;
    color: #473232;
  }
}
</style>
